import moment from 'moment';
import {
  is,
  or,
  not,
  filter,
  compose,
  isNil,
  pickBy,
  isEmpty,
  ifElse,
  when,
  curry,
  prop,
  propEq,
  map,
  path as rPath,
  pathEq as rPathEq,
  split,
  defaultTo,
  uniqBy,
  sort,
  toPairs,
  unnest as runnest,
} from 'ramda';

const isNotNil = compose(not, isNil);
const isVoid = (d) => or(isNil(d), isEmpty(d));
const isNotVoid = compose(not, isVoid);
export const clear = ifElse(is(Array), filter(isNotVoid), pickBy(isNotVoid));

export const whenNotNil = when(isNotNil);

export const expandIf = (c, functor) => (c && functor()) || {};

export const date = (d, format = 'MM-DD-YYYY') =>
  (d && moment(d, format).valueOf()) || null;

export const eq = (name, value, def, data) =>
  isNotVoid(prop(name, data)) ? propEq(name, value, data) : def;

const pathSplit = split('.');

export const path = curry((str, data) => rPath(pathSplit(str), data));

export const pathOr = curry((d, str, data) =>
  defaultTo(d, rPath(pathSplit(str), data))
);

export const pathEq = curry((str, value, data) =>
  rPathEq(pathSplit(str), value, data)
);

export const splash = compose(
  uniqBy(prop('id')),
  runnest, // beware, this is unnest from ramda.
  map(prop(1)),
  sort((a, b) => a[0] - b[0]),
  toPairs,
  defaultTo({})
);
